import { gql, useQuery } from '@apollo/client';

const SERVICE_TICKETS = gql`
  query ServiceTickets($status: String, $kind: String, $includeClosed: Boolean) {
    serviceTickets(status: $status, kind: $kind, includeClosed: $includeClosed) {
      id
      kind
      status
      serviceName
      serviceKey
      serviceUrl
      dsfaIndex
      contactEmail
      companyId
      companyName
      createdAt
      updatedAt
      resolvedAt
      category
      resolvedSnippetId
      customerMessage
      customerNotifiedAt
    }
  }
`;

export type ServiceTicketKind = 'NEW_SERVICE' | 'DSFA';
// Statusmodell = die vier HubSpot-Support-Pipeline-Stages
export type ServiceTicketStatus = 'NEW' | 'WAITING_ON_CONTACT' | 'WAITING_ON_US' | 'CLOSED';

export interface ServiceTicket {
  id: string;
  kind: ServiceTicketKind;
  status: ServiceTicketStatus;
  serviceName: string | null;
  serviceKey: string | null;
  serviceUrl: string | null;
  dsfaIndex: string | null;
  contactEmail: string | null;
  companyId: string;
  companyName: string;
  createdAt: string;
  updatedAt: string;
  resolvedAt: string | null;
  // Snippet-Kategorie, abgeleitet aus serviceKey (null bei DSFA/RANDOM_x)
  category: string | null;
  resolvedSnippetId: string | null;
  customerMessage: string | null;
  customerNotifiedAt: string | null;
}

export interface ServiceTicketsVariables {
  status?: ServiceTicketStatus;
  kind?: ServiceTicketKind;
  includeClosed?: boolean;
}

export interface ServiceTicketsData {
  serviceTickets: ServiceTicket[];
}

export function useServiceTicketsQuery(variables?: ServiceTicketsVariables) {
  return useQuery<ServiceTicketsData, ServiceTicketsVariables>(SERVICE_TICKETS, {
    variables,
    fetchPolicy: 'network-only',
  });
}
